import './Main.css';
import './CSS/Contact.css';
import {FooterLinks, HeaderLinks} from "./ToolBox.jsx"
import { Link } from 'react-router-dom';
import React, { useState } from 'react';

const openMaps = (system) => {
  const query = encodeURIComponent("Pennington Chapel 2712 Sandy Cross Rd, Royston, GA 30662");
  const urls = {
    Apple: `http://maps.apple.com/?q=${query}`,
    Google: `https://www.google.com/maps/search/?api=1&query=${query}`,
  };

  const url = urls[system] || urls.Google;
  window.open(url, "_blank", "noopener,noreferrer");
}

//The format for the forms
const InputField = ({ label, id, ...props }) => (
  <div className="InputField">
    <label htmlFor={id}>{label}</label>
    <input id={id} className="Boxes" {...props} />
  </div>
);

const MapButtons = () => {
  return(
    <table className="MapBox">
      <tbody>
        <tr>
          <th>Open in Google Maps!</th>
          <th>Open in Apple Maps!</th>
        </tr>
      </tbody>
      <tbody>
        <tr>
          <td><button onClick={openMaps} className="fa fa-map-marker"></button></td>
          <td><button onClick={() => openMaps("Apple")} className="fa fa-map-pin"></button></td>
        </tr>
      </tbody>
    </table>
  )
}

export default function ContactPage() {
  const [form, setForm] = useState({
    email: "",
    phone: "",
    FName: "",
    LName: "",
    Message: "",
    Concern: ""
  });
  const [errors, setErrors] = useState({});

  const handleSubmit = async (e) => {
    e.preventDefault();
    console.log("SUBMIT CLICKED");
    const validationErrors = validate();

    if (Object.keys(validationErrors).length === 0) {
      await fetch("https://pennington-chapel-server.onrender.com/send-email", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(form),
      });

      alert("Message sent!");
    }
    else {
      setErrors(validationErrors);
    }
  }
  //Form validation
  const validate = () => {
    const validationErrors = {};

    // Email
    if (!form.email) {
      validationErrors.email = "Email is required";
    } else if (!/\S+@\S+\.\S+/.test(form.email)) {
      validationErrors.email = "Invalid email format";
    }

    // Phone (optional, but has to be checked)
    const phone = form.phone?.trim(); //trims white space
    if (phone) {
      const cleaned = phone.replace(/\D/g, "");
      if (cleaned.length !== 10) {
        validationErrors.phone = "Phone must be 10 digits";
      }
    }
    return validationErrors;
  };

  const handleFormChange = (e) => {
    const { name, value } = e.target;
    setForm(prev => ({ ...prev, [name]: value }));
    setErrors(prev => {
      const updated = { ...prev };
      delete updated[name];
      return updated;
    });
  };
  const RadioButtons = () => {
    return(
      <div className="radioGroup">
        <label>
          <input type="radio" name="Concern" value="I have a prayer request!" checked={form.Concern === "I have a prayer request!"} onChange={handleFormChange} /> I have a prayer request!
        </label>
        <label>
          <input type="radio" name="Concern" value="I need to talk to a Pastor!" checked={form.Concern === "I need to talk to a Pastor!"} onChange={handleFormChange} /> I need to talk to a Pastor!
        </label>
        <label>
          <input type="radio" name="Concern" value="I have a question!" checked={form.Concern === "I have a question!"} onChange={handleFormChange} /> I have a question!
        </label>
        <label>
          <input type="radio" name="Concern" value="I want to visit the church!" checked={form.Concern === "I want to visit the church!"} onChange={handleFormChange} /> I want to visit the church!
        </label>
      </div>
    );
  }

  return(
    <div className="backgroundGradient">
      <Link to="/"><img src="/Images/Chapel Logo.png" alt="Pennington Chapel" /></Link>
      <HeaderLinks />
      <div className="banner">
        <h2 className="bannerText">Contact Us</h2>
      </div>
      <div className="grouped">
        <div className="grouped2">
          <form onSubmit={handleSubmit}>
            <p id="contactHelp">How can we help?</p>
            <InputField label="First Name:" id="FNameBox" name="FName" placeholder="Tsubaki" onChange={handleFormChange} required/>
            <InputField label="Last Name:" id="LNameBox" name="LName" placeholder="Myer" onChange={handleFormChange} required/>
            <InputField label="Phone number:" id="phoneNum" name="phone" type="tel" placeholder="(Optional)" onChange={handleFormChange}/>
            {errors.phone && <p className="error">{errors.phone}</p>}
            <InputField label="Email Address:" value={form.email} name="email" type="email" placeholder="TsubakiMyer@gmail.com" onChange={handleFormChange} required/>
            {errors.email && <p className="error">{errors.email}</p>}

            <div className="msgArea"> 
              <label>Send us a message! </label> 
              <textarea aria-required="true" id="CommentBox" name="Message" rows="7" cols="40" onChange={handleFormChange}></textarea>
            </div>
            <RadioButtons />
            <button type="submit">Submit</button>
          </form>
          <MapButtons />
        </div>
        <img src="/Images/Prayer Hands.jpg" id="prayHands" alt="Church Bible"/>
      </div>
      <FooterLinks />
    </div>
  );
}